import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { Card, Typography, Box, Skeleton, Alert, Button, Stack } from '@mui/material';
import { useChart } from '../../chart';
import Iconify from '../../iconify/Iconify';

const getSeries = (data) => [
  {
    name: 'Bookings',
    data: (data || []).map((item) => Number(item.bookings || 0)),
  },
  {
    name: 'Delivered',
    data: (data || []).map((item) => Number(item.delivered || 0)),
  },
  {
    name: 'Failed',
    data: (data || []).map((item) => Number(item.failed || 0)),
  },
];

export default function TrendsChart({ data, loading, error, onRetry }) {
  const categories = (data || []).map((item) => item.date || '');
  const chartOptions = useChart({
    chart: { type: 'line', toolbar: { show: false } },
    stroke: { width: [3, 3, 3], curve: 'smooth' },
    xaxis: { categories },
    markers: { size: 3 },
    yaxis: { min: 0, forceNiceScale: true },
    colors: ['#1976d2', '#2e7d32', '#d32f2f'],
    fill: {
      type: 'gradient',
      gradient: {
        shadeIntensity: 0.2,
        opacityFrom: 0.35,
        opacityTo: 0.05,
      },
    },
    tooltip: { shared: true, intersect: false },
  });

  return (
    <Card
      sx={{
        p: 2.25,
        borderRadius: 3,
        border: '1px solid',
        borderColor: 'divider',
        boxShadow: '0 8px 22px rgba(16, 24, 40, 0.05)',
        height: 360,
      }}
    >
      <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1.5 }}>
        <Iconify icon="solar:chart-square-bold-duotone" width={18} />
        <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
          Trends
        </Typography>
      </Stack>
      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1, fontSize: { xs: '0.72rem', md: '0.75rem' } }}>
        Bookings vs Delivered vs Failed
      </Typography>

      {error ? (
        <Alert
          severity="error"
          action={
            <Button color="inherit" size="small" onClick={onRetry}>
              Retry
            </Button>
          }
        >
          Failed to load trends.
        </Alert>
      ) : loading ? (
        <Skeleton variant="rectangular" height={280} sx={{ borderRadius: 2 }} />
      ) : (
        <Box sx={{ width: '100%', height: 280 }} dir="ltr">
          <ReactApexChart type="line" height={280} series={getSeries(data)} options={chartOptions} />
        </Box>
      )}
    </Card>
  );
}
